export default "__VITE_ASSET__Bw1CMMWQ__"